// Навигация: вкладки внизу, стек экранов, кнопка «назад» на Android (history), плавающая кнопка, заголовок.
import { $, el, esc } from './dom.ts';
import { NAV, S, UI, type Screen } from './state.ts';

export type ScreenFn = (app: HTMLElement, p: Record<string, unknown>) => void;
export const SCREENS: Record<string, ScreenFn> = {};

let onRenderEmpty: (() => void) | null = null;
export function setWelcomeRenderer(fn: () => void): void { onRenderEmpty = fn; }

export function pushHistory(sheet = false): void {
  try {
    const st: { n: number; sheet?: boolean } = { n: NAV.stack.length };
    if (sheet) st.sheet = true;
    history.pushState(st, '');
  } catch { /* без истории — только кнопки на экране */ }
}

export function current(): Screen {
  return NAV.stack.length ? NAV.stack[NAV.stack.length - 1]! : { name: NAV.tab, p: {} };
}

export function go(name: string, p: Record<string, unknown> = {}): void {
  NAV.stack.push({ name, p });
  pushHistory();
  render();
  window.scrollTo(0, 0);
}

export function replace(name: string, p: Record<string, unknown> = {}): void {
  NAV.stack[NAV.stack.length - 1] = { name, p };
  render();
}

let histBusy = 0;
export function histBack(): void {
  histBusy = Date.now() + 600;
  try { history.back(); } catch { /* нет истории */ }
}

export function back(): void {
  if (!NAV.stack.length) return;
  NAV.stack.pop();
  render();
  window.scrollTo(0, 0);
  const st = history.state as { n?: number } | null;
  if (st && (st.n ?? 0) > NAV.stack.length) histBack();
}

// закрыть нижнее окно — задаёт sheet.ts (чтобы не было круговой зависимости)
let closeSheetFn: (fromHistory?: boolean) => void = () => {};
export function setSheetCloser(fn: (fromHistory?: boolean) => void): void { closeSheetFn = fn; }

window.addEventListener('popstate', () => {
  if (Date.now() < histBusy) return;          // отголосок нашего же history.back(): стек уже поправлен
  if (!$('#sheet').hidden) { closeSheetFn(true); return; }
  const n = (history.state as { n?: number } | null)?.n ?? 0;
  if (n < NAV.stack.length) {
    while (NAV.stack.length > n) NAV.stack.pop();
    render();
  }
});

export function setTab(tab: string): void {
  closeSheetFn();
  NAV.tab = tab;
  NAV.stack = [];
  render();
  window.scrollTo(0, 0);
}

export function render(): void {
  if (!S) return;
  if (onRenderEmpty && !S.settings) { onRenderEmpty(); return; }
  const cur = current(), f = SCREENS[cur.name], app = $('#app');
  app.innerHTML = '';
  $('#fab').hidden = true;
  $('#fab').innerHTML = '';
  if (f) f(app, cur.p);
  else app.innerHTML = '<div class="empty">Экран «' + esc(cur.name) + '» ещё не готов</div>';
  renderNav();
}

const NAV_ICONS: Record<string, string> = {
  today: '<svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/>' +
    '<rect x="7" y="13" width="4" height="4" rx=".5"/></svg>',
  sched: '<svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="16" rx="2"/>' +
    '<path d="M3 10h18M8 3v4M16 3v4M9 10v11M15 10v11"/></svg>',
  clients: '<svg viewBox="0 0 24 24"><circle cx="9" cy="8" r="3.5"/><path d="M2.5 20a6.5 6.5 0 0 1 13 0"/>' +
    '<circle cx="17" cy="9" r="2.5"/><path d="M15.5 14.5a5 5 0 0 1 6 5"/></svg>',
  money: '<svg viewBox="0 0 24 24"><ellipse cx="12" cy="7" rx="7" ry="3"/>' +
    '<path d="M5 7v5c0 1.7 3.1 3 7 3s7-1.3 7-3V7M5 12v5c0 1.7 3.1 3 7 3s7-1.3 7-3v-5"/></svg>',
  more: '<svg viewBox="0 0 24 24"><circle cx="5" cy="12" r="1.6"/><circle cx="12" cy="12" r="1.6"/>' +
    '<circle cx="19" cy="12" r="1.6"/></svg>',
};
const NAV_LABEL: Record<string, string> = { today: 'Сегодня', sched: 'Расписание', clients: 'Клиенты', money: 'Деньги',
  more: 'Ещё' };

export function renderNav(): void {
  const n = $('#nav');
  n.hidden = false;
  n.innerHTML = '';
  const badge = (S.counts.review || 0) + (S.counts.receipts || 0);
  for (const k of ['today', 'sched', 'clients', 'money', 'more']) {
    const b = el('<button' + (NAV.tab === k ? ' class="on"' : '') + '>' + NAV_ICONS[k] + NAV_LABEL[k] +
      (k === 'money' && badge ? '<span class="bdg">' + badge + '</span>' : '') + '</button>');
    b.onclick = () => setTab(k);
    n.appendChild(b);
  }
}

export function fab(label: string, fn: () => void): void {
  const f = $('#fab');
  f.hidden = false;
  f.innerHTML = '<button class="fab"><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>' + esc(label) +
    '</button>';
  (f.firstChild as HTMLElement).onclick = fn;
}

export function title(text: string, sub?: string, noBack?: boolean): string {
  return '<div class="p-title">' + (noBack ? '' : '<button class="back" data-back>‹</button>') + '<span class="t">' +
    esc(text) + '</span>' + (sub ? '<span class="sub">' + esc(sub) + '</span>' : '') + '</div>';
}

document.addEventListener('click', (e) => {
  const b = (e.target as HTMLElement).closest?.('[data-back]');
  if (b) { e.preventDefault(); back(); }
});

// экран «Расписание» запоминает режим; черновик записи — пока открыт экран
export function resetBook(): void { UI.book = null; }
